import { createActionGroup, props } from '@ngrx/store';
import { IMaintenance } from 'src/app/core/models/general.model';

export const MaintenanceApiActions = createActionGroup({
  source: 'Maintenance API',
  events: {
    'Get Maintenance Flag': props<{ tenantId: string }>(),
    'Get Maintenance Flag Success': props<IMaintenance>(),
    'Get Maintenance Flag Failure': props<{ error: any }>(),
  },
});
